import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentNav: "index",
    // baseUrl: "http://192.168.0.231:8081", // 本地
    // fileUrlHeader: "http://192.168.0.231:8081", // 本地
    // baseUrl: "http://192.168.3.178:8071", // 测试
    // fileUrlHeader: "http://192.168.0.242:7080", // 测试
    baseUrl: "", // 线上
    fileUrlHeader: "", // 线上
  },
  mutations: {
    updateCurrentNav (state, val) {
      state.currentNav = val
    },
  },
  actions: {},
  modules: {},
})
